<template>

  <main id="renew2_login">
    <div class="login_container">
      <div class="renew2_wrapper renew2_flex">
        <div class="login_contents">
          <div class="renew2_flex lead">
            <h2>無料会員登録</h2>
          </div>
          <p>Yagishの<a href="/terms" id="footer-link-terms" target="_blank">利用規約</a>、<a
              href="https://www.yagish.jp/privacy/" class="" id="footer-link-terms"
              target="_blank">個人情報の取り扱いについて</a>に同意の上、会員登録してください。</p>
          <register-forms />
        </div>
      </div>
    </div>
  </main>

</template>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>

<script>
// import LoginForms from '@/components/RenewLoginForms'
import RegisterForms from '@/components/RegisterForms'
import firebase from 'firebase/app'
export default {
  components: {
    'register-forms': RegisterForms
  },
  data: function () {
    return {
      fullscreenLoading: true,
      isAgree: true
    }
  },
  created: function () {
    console.log('created')
    firebase.auth().onAuthStateChanged((user) => {
      //   if (user) {    
      //     const urlParams = new URLSearchParams(window.location.search);
      //     var from_page = urlParams.get("frompage");
      //     if (from_page) {
      //       this.$router.push('/format/' + from_page + '/edit/output')
      //     } else {
      //       console.log('register go mypage')
      //       location.href='/mypage'
      //       // //this.$router.push('/mypage')
      //     }
      //   }
      // this.fullscreenLoading = false
    })
  },
  computed: {},
  methods: {
    authStateChanged: async function () {
      const urlParams = new URLSearchParams(window.location.search);
      var from_page = urlParams.get("frompage");
      if (from_page) {
        this.$router.push('/format/' + from_page + '/edit/output')
      } else {
        // this.$router.push('/mypage')
        location.href = "/mypage"
      }
      console.log('new login created')
    }
  },
  watch: {},
  beforeMount: function () {
    this.$eventHub.$on('login_redirect_function', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('login_redirect_functionn', this.authStateChanged)
  }
}
</script>
